import { bannerBox } from '../../../components/BannerBox/tokens/cobalt/OP';
import { deprecatedButton } from '../../../deprecated/Button/tokens/cobalt/';
import type { ComponentTokens } from '../types';
import { baseComponents } from './base';

export const components: ComponentTokens = {
  ...baseComponents,
  bannerBox,
  deprecatedButton,
};
